import type { UserPhoneNumber } from '@entities/user';

export interface IntegrationSettings {
  instanceUrl: string;
  integrationId: number;
  sections: {
    general: {
      settings: {
        businessHours: boolean;
        caseCreation: boolean;
        contactSync: boolean;
        defaultOwner: {
          id: string;
          translatedLabel: string;
        };
        logCall: string;
        logCallRecordingUrl: string;
        logVoiceMailUrl: string;
        notifyRedirect: true;
        recordCreation: string;
        configureOmniChannelOn: string;
      };
    };
    [key: string]: {
      settings: IntegrationSettingsValues;
    };
  };
}

export interface SFIntegrationsettingSections {
  sections: {
    omnichannel_aircall_to_sf: {
      settings: AircallToSalesforce & IntegrationSettingsValues;
    };
    omnichannel_sf_to_aircall: {
      settings: SalesforceToAircall & IntegrationSettingsValues;
    };
    general: {
      settings: {
        businessHours: boolean;
        caseCreation: boolean;
        contactSync: boolean;
        defaultOwner: {
          id: string;
          translatedLabel: string;
        };
        logCall: string;
        logCallRecordingUrl: string;
        logVoiceMailUrl: string;
        notifyRedirect: true;
        recordCreation: string;
        configureOmniChannelOn: string;
      };
    };
    [key: string]: {
      settings: IntegrationSettingsValues;
    };
  };
}

export interface AircallToSalesforce {
  salesforce_in_call_status: 'nothing' | string;
}

export type AircallAvailability = 'nothing' | 'available' | 'unavailable';

export interface SalesforceToAircall {
  omnichannel_offline: AircallAvailability;
  [key: string]: AircallAvailability;
}

type IntegrationSettingValue =
  | string
  | number
  | boolean
  | undefined
  | { id: string | number; translatedLabel: string }
  | { id: string | number; translatedLabel: string; dataType: string };

interface IntegrationSettingsSectionSettings {
  settings: {
    [key: string]: IntegrationSettingValue | IntegrationSettingValue[];
  };
}

type IntegrationSettingsValues = IntegrationSettingsSectionSettings['settings'];
export interface CompanyIntegration {
  id: number;
  applicationId: number;
  status: string;
  numberIds: number[];
}

export interface PhoneNumberIntegrationIds {
  phoneNumber: UserPhoneNumber;
  integrationIds: number[];
}

export type PhoneNumberIntegrationIdsMap = {
  [key: string]: PhoneNumberIntegrationIds;
};

export enum IntegrationSettingsValueType {
  NOTHING = 'nothing',
}

export enum IntegrationSettingKeys {
  CONFIGURE_OMNICHANNEL_ON = 'configureOmniChannelOn',
  OMNICHANNEL_SF_TO_AIRCALL = 'omnichannel_sf_to_aircall',
}

export enum ConfigureOmniChannelOn {
  CURRENT_STATUS = 'current-status',
  PARENT_STATUS = 'parent-status',
}
